import request from "@/utils/request";
const api = {
    getListItem: '/api/web/nav/list',
}

export function getListItem(parameter){
    return request({url: api.getListItem, method: 'get', params: parameter})
}

